import { useSelector } from 'react-redux'
import { XIcon, TrashIcon } from '@phosphor-icons/react'
import {
    ScoopDrawer,
    ScoopButton,
    ScoopText,
    ScoopChip,
    ScoopStatusBubble,
    ScoopRow,
    ScoopColumn,
} from '../../../../ui'
import { formatToDDMMYY_HHMMampm } from '../../../../../utils/date'
import { EmailDrawerInfo } from '../EmailDrawerInfo/EmailDrawerInfo'
import { BotDrawerInfo } from '../BotDrawerInfo/BotDrawerInfo'
import { Server } from '../../../../../api/Server'
import styles from './HistoryDetailsDrawer.module.scss'

const HistoryDetailsDrawer = ({ open, onClose, logDetails, onReprocess, dataset }) => {
    const userID = useSelector((state) => state.auth.userID)
    const workspaceID = useSelector((state) => state.auth.workspaceID)
    const token = useSelector((state) => state.auth.token)

    const processTableContent = (result) => {
        const cleanedUrl = result?.url.replace(/\s+/g, '')
        window.open(cleanedUrl)
    }

    const handleTableContent = (inboxID, contentKey) => {
        const server = new Server(workspaceID, userID, token)
        server.postData(
            {
                action: 'getTableContent',
                inboxID: inboxID,
                contentKey: contentKey,
            },
            processTableContent
        )
    }

    return (
        <ScoopDrawer anchor="right" open={open} onClose={onClose} width="500px">
            <div className={styles.drawerContent}>
                <div className={styles.xButton} onClick={onClose}>
                    <XIcon size={24} weight="regular" />
                </div>
                {logDetails && (
                    <ScoopColumn className={styles.mainContainer}>
                        <ScoopText className={styles.headerTitle}>
                            {logDetails.timeStamp
                                ? formatToDDMMYY_HHMMampm(logDetails.timeStamp)
                                : ''}
                        </ScoopText>
                        <ScoopRow className={styles.statsContainer}>
                            <ScoopColumn className={styles.statItem}>
                                <ScoopText className={styles.statLabel}>Status</ScoopText>
                                <ScoopStatusBubble
                                    status={logDetails.rstiKey ? 'Success' : 'Failed'}
                                    withLabel
                                />
                            </ScoopColumn>
                            <ScoopColumn className={styles.statItem}>
                                <ScoopText className={styles.statLabel}>Table Scooped</ScoopText>
                                <ScoopText className={styles.statValue}>
                                    {logDetails.tableName ?? 'No Table'}
                                </ScoopText>
                            </ScoopColumn>
                            <ScoopColumn className={styles.statItem}>
                                <ScoopText className={styles.statLabel}>Rows Scooped</ScoopText>
                                <ScoopText className={styles.statValue}>
                                    {logDetails.numRows ?? '-'}
                                </ScoopText>
                            </ScoopColumn>
                        </ScoopRow>
                        {logDetails?.metadata ? (
                            <EmailDrawerInfo logDetails={logDetails} dataset={dataset} />
                        ) : (
                            <BotDrawerInfo logDetails={logDetails} dataset={dataset} />
                        )}
                        <ScoopColumn className={styles.logsSection}>
                            <ScoopText className={styles.logsTitle}>Logs details:</ScoopText>
                            <div className={styles.logsContainer}>
                                <ScoopColumn className={styles.logsList}>
                                    {logDetails && logDetails?.details?.length > 0 ? (
                                        logDetails?.details?.map((detail, index) => (
                                            <ScoopRow key={index} className={styles.logItem}>
                                                <ScoopText className={styles.logMessage}>
                                                    {detail.message}.
                                                </ScoopText>
                                                <ScoopText className={styles.logRows}>
                                                    {detail.numRows} rows
                                                </ScoopText>
                                                <ScoopChip
                                                    className={styles.chipContainer}
                                                    color={detail.type.toLowerCase()}
                                                    label={detail.type}
                                                />
                                            </ScoopRow>
                                        ))
                                    ) : (
                                        <ScoopText className={styles.emptyState}>
                                            No details available
                                        </ScoopText>
                                    )}
                                </ScoopColumn>
                            </div>
                        </ScoopColumn>
                    </ScoopColumn>
                )}

                <ScoopRow justify="space-between" className={styles.actionsContainer}>
                    <ScoopButton
                        variant="icon"
                        size="xs"
                        onClick={onClose}
                        className={styles.deleteButton}
                    >
                        <TrashIcon size={16} />
                    </ScoopButton>
                    <ScoopButton
                        size="xs"
                        onClick={() => {
                            if (logDetails.rstiKey)
                                handleTableContent(logDetails.inboxID, logDetails.contentKey)
                            else {
                                onClose()
                                onReprocess?.()
                            }
                        }}
                    >
                        {logDetails?.rstiKey ? 'View Processed Data' : 'Try Again'}
                    </ScoopButton>
                </ScoopRow>
            </div>
        </ScoopDrawer>
    )
}

export default HistoryDetailsDrawer
